import React from 'react';
import { Edit3, Eye } from 'lucide-react';

interface EditModeToggleProps {
  isEditMode: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function EditModeToggle({ isEditMode, onToggle, disabled = false }: EditModeToggleProps) {
  return (
    <div className="flex items-center gap-0 bg-blue-50 rounded-md border border-blue-200 p-1">
      <button
        onClick={() => isEditMode && onToggle()}
        disabled={disabled}
        className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
          !isEditMode
            ? 'bg-blue-600 text-white shadow-sm'
            : 'text-blue-700 hover:bg-blue-100'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : (!isEditMode ? 'cursor-default' : 'cursor-pointer')}`}
      >
        <Eye className="w-4 h-4 mr-2" />
        View Mode
      </button>
      
      <button
        onClick={() => !isEditMode && onToggle()}
        disabled={disabled}
        className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
          isEditMode
            ? 'bg-orange-600 text-white shadow-sm'
            : 'text-blue-700 hover:bg-blue-100'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : (isEditMode ? 'cursor-default' : 'cursor-pointer')}`}
      >
        <Edit3 className="w-4 h-4 mr-2" />
        Edit Mode
      </button>
    </div>
  );
}